import React from "react";

import Authorities from "../../../../auth/authorities";
import withAuthority from "../../../../components/Auth/withAuthority";
import HistoricalMetricPage from "./HistoricalMetricPage";

/**
 * INSIGHT-HIST-14 — Historical Load performance.
 *
 * The same screen as Preparation with the Load metric, so the two read the
 * same way and the controls behave identically.
 */
const HistoricalLoadPage: React.FunctionComponent<{}> = () => (
  <HistoricalMetricPage metricType="LOAD" title="Load Time Report" />
);

export default withAuthority(HistoricalLoadPage, Authorities.CUSTOMER_LIST_READ);
